import { getFont, truncated } from "@flatfile/design-system";
import { FlexCenter } from "../../common/UI/Flex.js";
import { ZIndex } from "../../common/UI/ZIndex.js";
import { TooltipStyles, buttonStyles, iconStrokeWidth } from "../Table/Styles.js";
import { defaultFontFamily } from "../../theme.js";
import styled, { css } from "styled-components";
const searchWidth = "244px";
const buttonFont = css`
  font-family: ${({ theme }) => theme.fontFamily !== defaultFontFamily ? theme.fontFamily : getFont("actionMd")};
  font-size: ${({ theme }) => theme.filters.fontSize} !important;
  color: ${({ theme }) => theme.filters.color};
`;
const ActionButtonWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
`;
const ToolbarContainer = styled.div`
  ${FlexCenter}
  gap: 12px;
  height: 48px;
  max-width: 100%;
  position: relative;
  padding: 0 12px;
  border-bottom: 1px solid ${({ theme }) => theme.indexColumn.borderColor};
  font-family: ${({ theme }) => theme.fontFamily} !important;
  z-index: 1;
  .tooltip {
    ${TooltipStyles}
  }

  .toolbar-icon-button button {
    color: ${({ theme }) => theme.buttons.iconColor} !important;
    .button-text {
      color: ${({ theme }) => theme.buttons.textColor} !important;
      ${buttonFont}
      ${truncated}
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .label {
      color: ${({ theme }) => theme.buttons.textColor} !important;
    }
    border-radius: 2px;
    padding-bottom: 1px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 1px;
  }

  ${ActionButtonWrapper} .styled-button {
    ${buttonStyles({ icon: false })}
    gap: 4px;

    ${iconStrokeWidth()}

    .button-text {
      ${buttonFont}
      ${truncated}
      display: flex;
      align-items: center;
      gap: 4px;
    }
  }
`;
const LightWeight = styled.span`
  font-weight: 400;
`;
const FilterButtonsContainer = styled.div`
  ${FlexCenter}
  height: 24px;
  background-color: ${({ theme }) => theme.filters.backgroundColor};
  border-radius: ${({ theme }) => theme.filters.outerBorderRadius} !important;
  float: left;
  z-index: 2;
  border: ${({ theme }) => theme.filters.outerBorder};
  overflow: hidden;
  flex-shrink: 0;
`;
const getSecondaryFontColor = ({
  theme,
  active,
  error
}) => {
  if (active) {
    return theme.filters.active.secondaryColor;
  }
  if (error) {
    return theme.filters.error.secondaryColor;
  }
  return theme.filters.secondaryColor;
};
const FilterTab = styled.div`
  ${FlexCenter}
  ${buttonFont}
  box-sizing: border-box;
  height: 100%;
  cursor: pointer;
  line-height: 16px;
  border-radius: ${({ theme }) => theme.filters.innerBorderRadius};
  overflow: hidden;
  flex-shrink: 0;

  ${({ disabled }) => disabled && `
    opacity: 0.75;
    cursor: default;
  `}

  ${({ theme, error }) => `
    color: ${error ? theme.filters.error.color : theme.filters.color};

    .count {
      color: ${getSecondaryFontColor({ theme, error })};
    }
  `}
  ${({ theme, active, error }) => active && `
    background-color: ${error ? theme.filters.error.activeBackgroundColor : theme.filters.active.backgroundColor};
    color: ${theme.filters.active.color};

    .count {
      color: ${getSecondaryFontColor({ theme, active })};
    }

    ${FilterRight} {
      background-color: ${error ? theme.filters.error.secondaryBackgroundColor : theme.filters.active.secondaryBackgroundColor};
    }
  `}
`;
const FilterLeft = styled.div`
  ${FlexCenter}
  gap: 2px;
  padding: 2px 8px;
  ${({ filtered, isLoading }) => filtered ? "padding-right: 4px;" : isLoading ? "padding-right: 6px;" : ""}
`;
const FilterRight = styled.div`
  ${FlexCenter}
  height: 100%;
  padding: 2px 4px 2px 0px;

  .spinner {
    margin: 0px 2px 0px 4px;
  }

  .count {
    padding: 0px 4px;
  }

  ${({ active, theme }) => !active && css`
      .count {
        border-radius: 4px;
        background-color: ${theme.filters.secondaryBackgroundColor};
      }
    `}
`;
const SearchWrapper = styled.div`
  flex-shrink: 0;
  height: 28px;
  float: left;
  width: ${({ collapsed }) => collapsed ? "24px" : searchWidth};
  transition: all 300ms;

  ${({ collapsed }) => collapsed && "overflow: hidden;"}

  .search-input-container {
    min-width: 32px;
    overflow: hidden;

    ${({ focused, theme }) => focused && css`
        border: 1px solid ${theme.inputs.search.borderColor};
      `}
  }

  > div {
    position: absolute;
    min-width: ${({ collapsed }) => collapsed ? 0 : searchWidth};
    max-width: calc(100% - 16px);
    transition: all 300ms;
    width: ${({ hasOverflow, collapsed, focused }) => {
  if (collapsed)
    return 0;
  if (!focused || !hasOverflow)
    return searchWidth;
  return "100%";
}};
    ${({ collapsed }) => !collapsed && `z-index: ${ZIndex.level1000};`}
  }

  input {
    font-family: ${({ theme }) => theme.fontFamily} !important;
  }
`;
export {
  FilterButtonsContainer,
  FilterLeft,
  FilterRight,
  FilterTab,
  LightWeight,
  SearchWrapper,
  ToolbarContainer,
  getSecondaryFontColor
};
